<app-table-header
  (reload)="onRefreshList()"
  [loading]="loading"
  [withExportOption]="false"
  >
  <div class="list-header">
    @if (!onlyClosed) {
      <div class="list-header__actions">
        <button nz-button nzType="secondary" [disabled]="selectedCount === 0" (click)="setUncompletedStatusForOrdersWithComment()">
          <i nz-icon nzType="comment" nzTheme="outline"></i><span>Bemerkungen prüfen ({{ selectedCount }})</span>
        </button>
        <button nz-button nzType="secondary" [disabled]="selectedCount === 0" (click)="openGenerateDeliverySlipsModal(generateDeliverySlipsModalComponent)">
          <i nz-icon nzType="inbox" nzTheme="outline"></i><span>Versandetiketten erstellen ({{ selectedCount }})</span>
        </button>
        <button nz-button nzType="secondary" (click)="generateRequiredDocuments()" [disabled]="selectedCount === 0 || documentsAreProcessing">
          <i nz-icon nzType="file-done" nzTheme="outline"></i><span>Lieferscheine und Rechnungen erstellen ({{ selectedCount }})</span>
        </button>
        <button nz-button nzType="secondary" (click)="generateBatchDocument()" [disabled]="selectedCount === 0 || !allDocumentsReady || documentsAreProcessing">
          <i nz-icon nzType="printer" nzTheme="outline"></i><span>Lieferscheine und Rechnungen drucken ({{ selectedCount }})</span>
        </button>
      </div>
    }

    <div class="filter-row">
      <div class="filter-row__group">
        <label>Anzahl der Positionen</label>
        <nz-select
          nzAllowClear
          [(ngModel)]="numberOfPositions"
          (ngModelChange)="onRefreshList()"
          class="full-width"
        >
          @for (item of numberOfPositionsOptions; track item.label) {
            <nz-option [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
          }
        </nz-select>
      </div>

      <div class="filter-row__group">
        <label>Lagerbereich (A-A, A-Z)</label>
        <div class="filter-row__range">
          <input
            type="text"
            nz-input
            class="filter-row__range-input"
            [(ngModel)]="storageRange.start"
            (ngModelChange)="storageRangeChanged()"
          >
          <span class="filter-row__range-sep">-</span>
          <input
            type="text"
            nz-input
            class="filter-row__range-input"
            [(ngModel)]="storageRange.end"
            (ngModelChange)="storageRangeChanged()"
          >
        </div>
      </div>

      <div class="filter-row__group">
        <label>Datum</label>
        <nz-date-picker
          [nzFormat]="dateFormat"
          [(ngModel)]="selectedDate"
          (ngModelChange)="onDateChange()"
          [nzAllowClear]="!onlyClosed"
        ></nz-date-picker>
      </div>

      <div class="filter-row__group">
        <label>Art der Zustellung</label>
        <nz-select
          class="filter-row__delivery"
          [(ngModel)]="selectedDeliveryMethod"
          [nzAllowClear]="true"
          (ngModelChange)="onRefreshList()"
        >
          @for (o of deliveryMethods; track o) {
            <nz-option [nzValue]="o" [nzLabel]="o"></nz-option>
          }
        </nz-select>
      </div>

      @if (onlyClosed) {
        <div class="filter-row__group">
          <label>Bearbeiter</label>
          <nz-select
            class="filter-row__bearbeiter"
            nzMode="multiple"
            nzAllowClear
            nzPlaceHolder="Alle"
            nzMaxTagCount="responsive"
            [(ngModel)]="selectedProcessors"
            (ngModelChange)="onRefreshList()"
          >
            @for (name of processors; track name) {
              <nz-option [nzValue]="name" [nzLabel]="name"></nz-option>
            }
          </nz-select>
        </div>
      }

      <div class="filter-row__right">
        <label
          class="filter-row__checkbox"
          nz-checkbox
          [(ngModel)]="showOnlyWithComments"
          (ngModelChange)="onRefreshList()"
        >Nur mit Kommentar anzeigen</label>
        @if (!onlyClosed) {
          <nz-select
            class="filter-row__status"
            [(ngModel)]="orderStatus"
            (ngModelChange)="onRefreshList()"
          >
            <nz-option [nzValue]="0" nzLabel="Offen"></nz-option>
            <nz-option [nzValue]="1" nzLabel="In Bearbeitung"></nz-option>
            <nz-option [nzValue]="46" nzLabel="Position unvollständig"></nz-option>
          </nz-select>
        }
      </div>
    </div>
  </div>
</app-table-header>

        <nz-table appColumnLayout
          #tableRef
          [nzScroll]="{ x: tableMaxWidth }"
          [nzData]="data"
          [nzLoading]="loading"
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          (nzQueryParams)="onTableQueryParams($event)"
          id="openorders-list-table"
          >
          <thead>
            <tr>
              @if (!onlyClosed) {
                <th data-col-key="selection"
                  [(nzChecked)]="checked"
                  [nzIndeterminate]="indeterminate"
                  (nzCheckedChange)="onAllChecked($event)"
                ></th>
              }
              <th nzColumnKey="id" nzWidth="100px" [nzSortFn]="true">#ID</th>
              <th nzColumnKey="fullDate" [nzSortFn]="true">Bestelldatum</th>
              <th nzColumnKey="number" [nzSortFn]="true">Bestellnummer</th>
              <th nzColumnKey="customer" [nzSortFn]="true">Kunde</th>
              <th nzColumnKey="status" [nzSortFn]="true">Aktueller Bestellstatus</th>
              <th nzColumnKey="trackingCode" [nzSortFn]="true">Versandetiketten generiert</th>
              <th nzColumnKey="isInvoiceRequired" [nzSortFn]="true">Rechnung erforderlich</th>
              <th nzColumnKey="isInvoiceGenerated" [nzSortFn]="true">Rechnung erstellt</th>
              <th nzColumnKey="isDeliveryNoteGenerated" [nzSortFn]="true">Lieferschein generiert</th>
              @if (onlyClosed) {
                <th nzColumnKey="processedBy" [nzSortFn]="true">Bearbeiter</th>
                <th nzColumnKey="processingStartedAt" [nzSortFn]="true">Start</th>
                <th nzColumnKey="processingFinishedAt" [nzSortFn]="true" nzSortOrder="descend">Ende</th>
                <th nzColumnKey="processingDurationSeconds" [nzSortFn]="true">Dauer</th>
                <th nzColumnKey="cartons">Kartons</th>
              }

              <th nzColumnKey="actions"></th>
            </tr>
          </thead>
          <tbody>
            @for (order of data; track order.id) {
              <tr>
                @if (!onlyClosed) {
                  <td [nzChecked]="setOfCheckedId.has(order.id)" (nzCheckedChange)="onItemChecked(order.id, $event)"></td>
                }
                <td>{{order.id}}</td>
                <td>{{order.fullDate|dateFormat}}</td>
                <td class="cell-nowrap order-number-cell">{{order.number}} <app-order-comments [order]="order"></app-order-comments></td>
                <td>{{order.customer}}</td>
                <td>{{order.status}}</td>
                <td nzAlign="center">
                  <app-boolean-icon [state]="order.trackingCode !== ''"
                  nz-tooltip [nzTooltipTitle]="order.deliveryMethodName"></app-boolean-icon>
                </td>
                <td nzAlign="center"> <app-boolean-icon [state]="order.isInvoiceRequired"></app-boolean-icon></td>
                <td nzAlign="center"> <app-boolean-icon [state]="order.isInvoiceGenerated"></app-boolean-icon></td>
                <td nzAlign="center"> <app-boolean-icon [state]="order.isDeliveryNoteGenerated"></app-boolean-icon></td>
                @if (onlyClosed) {
                  <td>{{order.processedBy || '—'}}</td>
                  <td>{{order.processingStartedAt ? (order.processingStartedAt|datetimeFormat) : '—'}}</td>
                  <td>{{order.processingFinishedAt ? (order.processingFinishedAt|datetimeFormat) : '—'}}</td>
                  <td>{{order.processingDurationSeconds|durationFormat}}</td>
                  <td>{{formatCartons(order.cartons)}}</td>
                }
                <td>
                  @if (order.documentKey) {
                    <div class="actions">
                      <app-download-document [documentKey]="order.documentKey"></app-download-document>
                      @if (!onlyClosed) {
                        <app-icon-button
                          icon="sync"
                          [ariaLabel]="'Dokument neu erstellen: ' + order.id"
                          (pressed)="regenerateDocument(order.id)"
                        ></app-icon-button>
                      }
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </nz-table>
        <ng-template #progressBar>
          <nz-progress [nzPercent]="percentDone"></nz-progress>
        </ng-template>
        <ng-template #modalFooter>
          <button nz-button nzType="primary">Speichern</button>
        </ng-template>

        <app-document-pdf-safari-modal [pdfLink]="pdfLink">

        </app-document-pdf-safari-modal>

        <app-generate-delivery-slips-modal (generated)="onRefreshList()"  #generateDeliverySlipsModalComponent>

        </app-generate-delivery-slips-modal>

        <app-export-table-modal #exportTableModalComponent></app-export-table-modal>
